import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../axios'

export interface MalariaAnalysisCase {
  id: string
  slideId: string
  date: string
  imageCount: number
  status: string
  summary: string
  infectedRbcCount: number
  uninfectedRbcCount: number
  parasitemiaPercent: number
  detectionProfile?: string | null
  images: Array<{
    id: string
    imageUrl: string
    infectedRbcCount: number
    uninfectedRbcCount: number
    parasitemiaPercent: number
    createdAt: string
    positiveBoxes: number[][]
    negativeBoxes: number[][]
    detectionProfile?: string | null
  }>
}

interface MalariaAnalysesResponse {
  success: boolean
  cases: MalariaAnalysisCase[]
}

/**
 * Fetch all malaria lab analyses for the current user
 */
export const useLabMalariaAnalyses = () => {
  return useQuery({
    queryKey: ['labMalariaAnalyses'],
    queryFn: async (): Promise<MalariaAnalysisCase[]> => {
      const response = await axiosClient.get<MalariaAnalysesResponse>('/analysis/malaria/lab-cases')
      return response.data.cases
    },
  })
}
